module.exports = __webpack_public_path__ + "26b8347be7ad4ce22cc8292c0f7438c4.svg";